import { Inject, Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { HttpParams } from '@angular/common/http';
import {
  ApiResponseModel,
  CourseHistoryAbstractListingModel,
  CourseHistoryListingModel,
  CourseHistoryModel,
  CourseListingFilterModel,
  Environment,
  ENVIRONMENT_TOKEN,
} from '@lms/shared/models';
import { Router, UrlSerializer } from '@angular/router';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class StudentCourseHistoryService {
  constructor(
    private apiService: ApiService,
    private router: Router,
    private urlSerializer: UrlSerializer,
    @Inject(ENVIRONMENT_TOKEN) private environment: Environment,
  ) {}

  listing(filter: CourseListingFilterModel): Observable<ApiResponseModel<CourseHistoryAbstractListingModel>> {
    const params = new HttpParams()
      .set('pageNumber', filter.pageNumber?.toString() || '')
      .set('sort', filter.sort?.toString() || '')
      .set('pageSize', filter.pageSize?.toString() || '');

    return this.apiService
      .executeGet<ApiResponseModel<CourseHistoryListingModel>>('courses/learning_history', params)
      .pipe(map(data => this.mapCourseHistoryListingModel(data)));
  }

  getEntity(): Observable<CourseHistoryModel> {
    return EMPTY;
  }

  private mapCourseHistoryListingModel(
    response: ApiResponseModel<CourseHistoryListingModel>,
  ): ApiResponseModel<CourseHistoryAbstractListingModel> {
    return {
      status: response.status,
      data: {
        ...response.data,
        itemsList: response.data.courses,
      },
    };
  }
}
